import type { CompactPropertyFact } from "@/utils/compact-property-facts";

export default function CompactPropertyFactValue({
  fact,
}: {
  fact: CompactPropertyFact;
}) {
  if (fact.value === null) return <span>-</span>;
  return (
    <span>
      {fact.value}
      {fact.unit === "m²" ? (
        <>
          {" "}
          m<sup>2</sup>
        </>
      ) : fact.unit ? (
        ` ${fact.unit}`
      ) : null}
    </span>
  );
}
